import React, { useEffect, useRef, useState } from 'react'
import { API_URL } from '../../../../../../api/api'
import { getDataFromServer } from '../../../../../../utils/apiUtils'
import { AppUtils } from '../../../../../../utils/appUtils'
import { Box, Card, CardContent, Divider, Grid, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from '@mui/material'
import { AppMisc } from '../../../../../../misc/appMisc'
import { GENDER_OPTIONS, NO_RECORDS_FOUND, PHYSIO_THERAPY_CODE } from '../../../../../../utils/constants'
import { Delete, Edit } from '@mui/icons-material'
import InfiniteScroll from 'react-infinite-scroll-component'

const PhysiotherapySewaBibaranRegister = ({ page, totalSize, ...props }) => {

  const [mainRegisterData, setMainRegisterData] = useState([]);
  const tableRef = useRef();
  const id = AppUtils.getUrlParam("id");
  const [cardData, setCardData] = useState([]);

  useEffect(() => {
    if (props.tableData !== null) {
      if (page) {
        setMainRegisterData(prev => {
          return [...prev, ...props.tableData];
        });
      } else {
        tableRef.current.scrollTo(0, 0);
        setMainRegisterData(props.tableData);
      }
    }
  }, [props.tableData]);

  const fetchData = () => {
    props.handleChangePage(page + 1);
    props.getTableData(true);
  };

  const getCardData = async () => {
    let url = API_URL.physiotherapySewaRegister + "/" + id
    let response = await getDataFromServer(url)
    if (response) {
      setCardData(response)
    }
  }

  useEffect(() => {
    getCardData()
  }, [])
  return (
    <>
      <Card>
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="subtitle1">सेवाग्राहीको सामान्य विवरण</Typography>
              <Divider />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              दर्ता मिति:{AppMisc.getDateLabelFromMillisecond(cardData?.dartaaMiti)}
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              नाम:{cardData?.patientFirstName}
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              थर:{cardData?.patientLastName}
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              उमेर:{cardData?.age && AppUtils.replaceWithNepaliDigit(cardData.age) + "वर्ष"}
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              लिङ्ग:{cardData?.gender && AppMisc.findLabelFromValue(GENDER_OPTIONS, cardData.gender)}
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              जिल्ला:{cardData?.district && AppMisc.getDistrictName(cardData.district)}
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              नगर/गाउँपालिका:{cardData?.palikaName}
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              वडा नं:{cardData?.wardNumber && AppUtils.replaceWithNepaliDigit(cardData.wardNumber)}
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              टोल:{cardData?.gaunOrTole}
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              सम्पर्क नं.:{cardData?.phoneNumber && AppUtils.replaceWithNepaliDigit(cardData?.phoneNumber)}
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      <InfiniteScroll
        dataLength={mainRegisterData?.length}
        next={fetchData}
        hasMore={mainRegisterData?.length !== totalSize}
        loader={<p style={{ textAlign: "center" }} className="print-none">Loading....</p>}
        scrollableTarget="mul-dartaa-register"
      >
        <TableContainer classes={{ root: "fixed-head-table-container" }} ref={tableRef}>
          <Table classes={{ root: "table-bordered normal-spacing" }} size="small" aria-label="Physio-therapy- Register">
            <TableHead classes={{ root: "align-center fixed-header header-sm" }}>
              <TableRow>
                <TableCell rowSpan={3}>क्रम संख्या</TableCell>
                <TableCell rowSpan={3}>मिति</TableCell>
                <TableCell colSpan={7}>फिजियोथेरपी सेवा प्रकार</TableCell>
                <TableCell rowSpan={3}>अन्य </TableCell>
                <TableCell rowSpan={3}>सम्पादन</TableCell>
              </TableRow>
              <TableRow>
                <TableCell rowSpan={2}>म्यानुअल थेरापी</TableCell>
                <TableCell rowSpan={2}>एक्सरसाइज थेरापी</TableCell>
                <TableCell colSpan={5}>इलेक्टो थेरापी</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>टेप्स</TableCell>
                <TableCell>यूएसजी</TableCell>
                <TableCell>आईएफटी</TableCell>
                <TableCell>मसल स्टिमुलेटर</TableCell>
                <TableCell>ट्रैक्शन</TableCell>
              </TableRow>
            </TableHead>
            <TableBody classes={{ root: "align-center" }}>
              {mainRegisterData?.length > 0 ? (
                mainRegisterData?.map((row, index) => (
                  <TableRow key={row.id}>
                    <TableCell>{AppUtils.replaceWithNepaliDigit(index + 1)}</TableCell>
                    <TableCell>{AppMisc.getDateLabelFromMillisecond(row?.dartaaMiti)}</TableCell>
                    <TableCell>{row?.physioTherapyType === "MANUAL_THERAPY" ? AppMisc.findLabelFromValue(PHYSIO_THERAPY_CODE, row?.physioTherapyType) : "-"}</TableCell>
                    <TableCell>{row?.physioTherapyType === "EXERCISE_THERAPY" ? AppMisc.findLabelFromValue(PHYSIO_THERAPY_CODE, row?.physioTherapyType) : "-"}</TableCell>
                    <TableCell>{row?.physioTherapyType === "TAPES" ? AppMisc.findLabelFromValue(PHYSIO_THERAPY_CODE, row?.physioTherapyType) : "-"}</TableCell>
                    <TableCell>{row?.physioTherapyType === "UST" ? AppMisc.findLabelFromValue(PHYSIO_THERAPY_CODE, row?.physioTherapyType) : "-"}</TableCell>
                    <TableCell>{row?.physioTherapyType === "IFT" ? AppMisc.findLabelFromValue(PHYSIO_THERAPY_CODE, row?.physioTherapyType) : "-"}</TableCell>
                    <TableCell>{row?.physioTherapyType === "TRACTION" ? AppMisc.findLabelFromValue(PHYSIO_THERAPY_CODE, row?.physioTherapyType) : "-"}</TableCell>
                    <TableCell>{row?.physioTherapyType === "MUSCLE_STIMULATOR" ? AppMisc.findLabelFromValue(PHYSIO_THERAPY_CODE, row?.physioTherapyType) : "-"}</TableCell>
                    <TableCell>{row?.physioTherapyType === "OTHER" ? AppMisc.findLabelFromValue(PHYSIO_THERAPY_CODE, row?.physioTherapyType) : "-"}</TableCell>
                    <TableCell>
                      <Box display="flex" alignItems="center">
                        <IconButton aria-label="edit" onClick={() => props.onEditRow(row.id)}>
                          <Edit fontSize="small" />
                        </IconButton>
                        <Tooltip title="रेकर्ड हटाउन यहा क्लिक गर्नुहोस" placement="top" arrow>
                          <IconButton color="secondary" onClick={() => props.deleteRow(row.id)}>
                            <Delete fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan="11" size="medium">{NO_RECORDS_FOUND}</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </InfiniteScroll>

    </>
  )
}

export default PhysiotherapySewaBibaranRegister;